import LazyVerifyPage from './LazyVerifyPage'

export default LazyVerifyPage
